import React from 'react';
import ImageUploader from '../image-uploader/image-uploader';
import LayerData from './layer-data';
import './stage-editor.css';

/** @class ImageLayerData
 * A component for editing image layer-specific properties.
 */
export default class ParallaxLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Parallax Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <ImageUploader
            name="Parallax Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={(url) => this.handleImageUpload("image", url)}
            />
        </div>
        <div className="input-group">
          <label htmlFor="depth">Depth</label><br/>
          <input name="scale" type="number"
            value={this.state.scale}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/parallax-layer-data.js